import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import _CircularWithLabel from './CircularWithLabel';
import _FileUploader from './FileUploader';

const labelMaker = (progress: number) => {
  if (progress < 100) {
    return `${progress}%`;
  } else {
    return <FormattedMessage id="submission_creative.processing_label" />;
  }
};

type Props = ClassAttributes<HTMLElement> & {
  className?: string;
  progress: number;
};

const noop = () => undefined;

const FileUploaderProcessing = ({ className, progress }: Props) => (
  <Root className={className}>
    <FileUploader onRequestFileUpload={noop} />
    <CircularWithLabel
      progress={progress}
      label={labelMaker(progress)}
      variant={progress < 100 ? 'determinate' : 'indeterminate'}
      size={112}
    />
  </Root>
);

const Root = styled('div')({ position: 'relative' });

const FileUploader = styled(_FileUploader)({
  width: '100%',
  height: '100%',
});

const CircularWithLabel = styled(_CircularWithLabel)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  background: 'rgba(0, 0, 0, .5)',
  borderRadius: 8,
});

export default FileUploaderProcessing;
